"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var NOTIFICATION_TYPES = [
    "success",
    "error",
    "warning"
];
var DEFAULT_TYPE = "success";
var createElement = function(tagName, text, className) {
    var el = document.createElement(tagName);
    if (className) el.classList.add(className);
    el.textContent = text;
    return el;
};
var appendChildren = function(parentEl) {
    for(var _len = arguments.length, children = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        children[_key - 1] = arguments[_key];
    }
    var // children.forEach((el) => parentEl.append(el));
    _parentEl;
    (_parentEl = parentEl).append.apply(_parentEl, _to_consumable_array(children));
};
var createNotification = function(posTop, posRight, title, description, type) {
    var notif = document.createElement("div");
    var resolvedType = NOTIFICATION_TYPES.includes(type) ? type : DEFAULT_TYPE;
    notif.classList.add("notification", resolvedType);
    notif.style.top = "".concat(posTop, "px");
    notif.style.right = "".concat(posRight, "px");
    var titleEl = createElement("h2", title, "title");
    var descEl = createElement("p", description);
    appendChildren(notif, titleEl, descEl);
    return notif;
};
var pushNotification = function(posTop, posRight, title, description, type) {
    var notif = createNotification(posTop, posRight, title, description, type);
    document.body.append(notif);
    setTimeout(function() {
        notif.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.8d09937d.js.map
